import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { animateScroll } from 'react-scroll'

import { phaseChange, reroute, storeDumpItForce } from '../../../actions/Buy'
import {
  findomesticCheckFirma,
  getInfocertCertificato,
} from '../../../actions/buy/Findomestic'
import {
  findomesticCheckFirmaV2,
  getInfocertCertificatoV2,
} from '../../../actions/buy/FindomesticFirmaV2'
import { enhancedEcommerceTracker } from '../../../tracking/EnhancedEcommerce/tracker'
import {
  CRITEO_EVENTS,
  EVENT_TYPES,
  triggerClickStreamEvent,
} from '../../triggerDataLayerEvent'

class ThanksFindomestic extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.state.toTop = false
    this.startFirma = this.startFirma.bind(this)
    this.startFirmaV2 = this.startFirmaV2.bind(this)
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register')
    }
  }

  componentDidMount() {
    this.props.phaseChange({
      phase: 105,
      last: this.props.ui.last > 105 ? this.props.ui.last : 105,
    })
    if (!this.state.toTop) {
      animateScroll.scrollToTop()
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ toTop: true })
    }

    if (this.props.customer && this.props.customer.token) {
      this.props
        .findomesticCheckFirma()
        .then(() => this.props.storeDumpItForce())
      this.props
        .findomesticCheckFirmaV2()
        .then(() => this.props.storeDumpItForce())
    }

    enhancedEcommerceTracker
      .pushPurchase({
        logistica: this.props.logistica,
        ordine: this.props.ordine,
        product: this.props.product,
      })
      .then(() => {})

    triggerClickStreamEvent(
      CRITEO_EVENTS.GROSS_ORDER_RETAIL,
      EVENT_TYPES.CRITEO,
      {
        email: this.props.customer.email,
        idAuto: this.props.product.id_auto,
        transactionId: this.props.ordine.id_ordine,
      }
    )
  }

  startFirma() {
    const t = this
    return () => {
      if (this.props.customer && this.props.customer.token) {
        t.props.reroute().then(() => {
          t.props.getInfocertCertificato().then(() => {
            t.props.reroute('/certificato-infocert')
          })
        })
      }
    }
  }

  startFirmaV2() {
    const t = this
    return () => {
      if (this.props.customer && this.props.customer.token) {
        t.props.reroute().then(() => {
          t.props.getInfocertCertificatoV2().then(() => {
            t.props.reroute('/v2/certificato-infocert')
          })
        })
      }
    }
  }

  checkFirma() {
    const t = this
    return event => {
      event.preventDefault()
      t.props.reroute().then(() => {
        t.props.findomesticCheckFirma().then(() => t.props.storeDumpItForce())
      })
    }
  }

  render() {
    const { customer, product } = this.props
    return (
      <div className="thank-you-wrapper">
        <div className="container--small">
          <h5 className={'section-title --reduced secondary'}>
            <i className={'icon-check-bold'} />
            {customer.nome} congratulazioni!
            <br />
            Sei ad un passo dal guidare la tua {product.marca} {product.modello}
          </h5>
          {!!this.props.findomestic.can_sign && (
            <p>
              Per completare la richiesta di finanziamento e l'ordine, prosegui
              alla firma digitale del contratto con Findomestic
            </p>
          )}
          {!this.props.findomestic.can_sign && (
            <div>
              <p>
                Per completare la richiesta di finanziamento e l'ordine, abbiamo
                bisogno di verificare delle informazioni
              </p>
              <p>Cosa succede ora?</p>
            </div>
          )}

          {!this.props.findomestic.can_sign && (
            <div className={'next-steps white-bg center mb-30'}>
              <h4>
                Prossimi passi
                <i className={'icon-custom-underline'} />
              </h4>
              <ul>
                <li>
                  <i className={'icon-check-bold'} />
                  Un consulente dedicato ti contatterà al numero{' '}
                  {customer.phone} per verificare i dati
                </li>
                <li>
                  <i className={'icon-check-bold'} />
                  Se la richiesta di finanziamento andrà a buon fine riceverai
                  una mail per proseguire alla firma digitale del contratto
                </li>
              </ul>
            </div>
          )}
          {this.props.findomestic.can_sign_v2 ? (
            <div className={'thank-you__button'}>
              <div className="btn btn-primary" onClick={this.startFirmaV2()}>
                <span>Firma Digitale</span>
              </div>
            </div>
          ) : null}
          <hr />
          <h5 className={'section-title --reduced secondary'}>
            Dubbi? siamo qui per risponderti
          </h5>
          <p className="mb-30">
            Il nostro servizio clienti è a tua disposizione per qualsiasi dubbio
            e domanda.
          </p>
          <a
            className="thankyou-support-btn btn btn-secondary"
            href={`tel:${this.props.ui.settings.phoneNumber}`}
            title="Servizio Clienti"
          >
            <i className="icon-phone-bold" />
            <span>Contattaci</span>
          </a>
        </div>
      </div>
    )
  }
}

ThanksFindomestic.propTypes = {
  logistica: PropTypes.object,
  product: PropTypes.object.isRequired,
  payment_method: PropTypes.string,
  ordine: PropTypes.object.isRequired,
  customer: PropTypes.object.isRequired,
  findomestic: PropTypes.object,
  ui: PropTypes.object,
  phaseChange: PropTypes.func,
  storeDumpItForce: PropTypes.func,
  findomesticCheckFirma: PropTypes.func,
  findomesticCheckFirmaV2: PropTypes.func,
  getInfocertCertificato: PropTypes.func,
  getInfocertCertificatoV2: PropTypes.func,
  reroute: PropTypes.func,
}

const mapStateToProps = state => ({
  logistica: state.logistica,
  product: state.product,
  ordine: state.ordine,
  findomestic: state.findomestic,
  payment_method: state.payment.method,
  customer: state.customer,
  ui: state.ui,
})

const mapDispatchToProps = dispatch => ({
  phaseChange: payload => dispatch(phaseChange(payload)),
  storeDumpItForce: payload => dispatch(storeDumpItForce(payload)),
  reroute: payload => dispatch(reroute(payload)),
  findomesticCheckFirma: () => dispatch(findomesticCheckFirma),
  findomesticCheckFirmaV2: () => dispatch(findomesticCheckFirmaV2),
  getInfocertCertificato: () => dispatch(getInfocertCertificato),
  getInfocertCertificatoV2: () => dispatch(getInfocertCertificatoV2),
})

export default connect(mapStateToProps, mapDispatchToProps)(ThanksFindomestic)
